import React, { useCallback, useEffect } from "react";
import { ReactComponent as CloseIcon } from "../../assets/icons/close-icon.svg";
import "./popupWrapper.css"

const PopupWrapper = ({ onClose, children }) => {
  const handleOverlayClick = useCallback(
    (e) => {
      e.stopPropagation();
      onClose();
    },
    [onClose]
  );

  const stopPropagation = useCallback((e) => e.stopPropagation(), []);

  useEffect(() => {
    // Add lock class to the body when the popup is opened
    document.body.classList.add("no-scroll");

    // Remove the lock class from the body when the popup is closed
    return () => document.body.classList.remove("no-scroll");
  }, []);
  return (
    <div className="popup-overlay" onClick={handleOverlayClick}>
      <div className="popup-content" onClick={stopPropagation}>
        <CloseIcon
          aria-label="Close popup"
          className="popup-close"
          onClick={onClose}
        />
        {children}
      </div>
    </div>
  );
};

export default PopupWrapper;
